import React, { CSSProperties, FunctionComponent, KeyboardEvent, SyntheticEvent, useCallback } from "react";

interface IProps {
	id?: string;
	children: React.ReactNode;
	className?: string;
	style?: CSSProperties;
	title?: string;
	tabIndex?: number;
	onClick(event?: SyntheticEvent<HTMLDivElement>): void;
	onKeyDown?(event: any): void;
}

const ClickableDiv: FunctionComponent<IProps> = (props) => {
	const { id, children, className, style, title, tabIndex, onClick, onKeyDown: onKeyDownExtra } = props;

	const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === " ") {
			event.preventDefault();
			onClick(event);
		}
		onKeyDownExtra?.(event);
	}

	const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === " " || event.key === "Enter") {
			onClick(event);
		}
	};

	const onDivClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
		onClick(event);
	}, [onClick]);

	return <div id={id} style={style} className={className} tabIndex={tabIndex ?? 0} onClick={onDivClick} onKeyDown={onKeyDown} onKeyPress={onKeyPress} title={title}>
		{children}
	</div>;
};

export default ClickableDiv;